import React, { Fragment, PureComponent } from 'react'
import Menu from '../../Components/Menu/CommonMenu'
import MenuItem from '../../Components/common/MenuItem'
import { ReactComponent as PmsIcon } from '../../assets/nav/mised-opportunity-01.svg'
import { Trans as Translate } from 'react-i18next'
import { Tooltip } from '@mui/material'
import { withRouter } from 'react-router-dom'
import { checkPrivileges } from '../../Helpers'

class PmsMenu extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      anchorEl: null
    }
    this.navigate = this.navigate.bind(this)
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  navigate (path) {
    this.handleClose()
    if (this.props.collapseMenu) {
      this.props.collapseMenu()
    }
    this.props.history.push(path)
  }

  render () {
    const { anchorEl } = this.state
    const { location } = this.props
    const isActive =
      location.pathname === '/missed-opportunities' ||
      location.pathname === '/user-pms'
    const showAiPms = checkPrivileges('aiPms')
    const showUserPms = checkPrivileges('aiPms')

    if (!showAiPms && !showUserPms) {
      return null
    }

    return (
      <Fragment>
        <Tooltip
          title={<Translate i18nKey='pms' />}
          placement='right'
          classes={{
            popper: 'menu-popper',
            tooltip: 'menu-popper-tooltip'
          }}
        >
          <a
            className={`navbar-menu-item${isActive ? ' active' : ''}`}
            href={null}
            aria-owns={anchorEl ? 'simple-menu-pms' : undefined}
            aria-haspopup='true'
            onClick={this.handleClick}
          >
            <PmsIcon fill='currentColor' width={20} height={20} />
            <span className='nav-link-text'>
              <Translate i18nKey='pms' />
            </span>
          </a>
        </Tooltip>
        <Menu
          id='simple-menu-pms'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          themecolors={this.props.themecolors}
        >
          {showAiPms ? (
            <MenuItem onClick={() => this.navigate('/missed-opportunities')}>
              <Translate i18nKey='aiPms' />
            </MenuItem>
          ) : null}
          {showUserPms ? (
            <MenuItem onClick={() => this.navigate('/user-pms')}>
              <Translate i18nKey='userPms' />
            </MenuItem>
          ) : null}
        </Menu>
      </Fragment>
    )
  }
}

export default withRouter(PmsMenu)
